  document.addEventListener('DOMContentLoaded', function () {
    var buttons = document.querySelectorAll('.bundle-addTocart');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        var variantId = btn.getAttribute('data-variant-id');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
          }),
        }).then(function () {
          window.location.href = '/cart';
        });
      });
    });
  });